import { Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";

interface GridColDefProps {
  headerName: string;
  onDelete: (id: number | string) => {},
}

export function generateActionsGridColDef({ headerName, onDelete }: GridColDefProps): GridColDef {
  return {
    field: 'actions',
    type: 'actions',
    headerName,
    width: 100,
    renderCell: ({ id, api }) => {
      return (
        <>
          <IconButton
            onClick={() => onDelete(id)}
            id={`delete-${id}`}>
            <Delete />
          </IconButton>
        </>
      );
    },
  };
}
